<router-outlet></router-outlet>

<simple-notifications></simple-notifications>

<p-dialog
   class="maintenance-dialog"
   [modal]="true"
   [closable]="false"
   [draggable]="false"
   [header]="'Scheduled Maintenance Notice'"
   [visible]="configService.showMaintenanceDialog"
>
   <span [innerHTML]="configService.maintenanceDialogMessage"></span>
</p-dialog>
